/* eslint-disable @typescript-eslint/no-explicit-any */
import { CommonModule } from '@angular/common';
import { Component, ContentChild, DestroyRef, inject, Input, OnInit, TemplateRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ChatDataActions, selectTempFiles } from '@iese-chatbot/chat-data-access';
import { Store } from '@ngrx/store';
import { RadioButtonModule } from 'primeng/radiobutton';

@Component({
  selector: 'icbc-switchable-content',
  imports: [CommonModule, ReactiveFormsModule, RadioButtonModule],
  templateUrl: './switchable-content.component.html',
  standalone: true,
})
export class SwitchableContentComponent implements OnInit {
  @Input() label = 'Content';
  @Input() inputId = 'content';
  @Input() name = 'mode';
  @Input() formGroup!: FormGroup;
  @Input() controlName = 'mode';
  @Input() fileAwareFields: string[] = [];

  @ContentChild('textTemplate') textTemplate?: TemplateRef<any>;
  @ContentChild('fileTemplate') fileTemplate?: TemplateRef<any>;

  private readonly _destroyRef = inject(DestroyRef);
  private readonly _store = inject(Store);

  get control() {
    return this.formGroup.get(this.controlName) as FormControl<string> | undefined;
  }

  get mode() {
    return this.control?.value;
  }

  public ngOnInit(): void {
    this._store
      .select(selectTempFiles)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((files) => {
        if (files && files.length > 0) {
          this.formGroup.get(this.controlName)?.patchValue('file', { emitEvent: true });
        }
      });
    this.formGroup
      .get(this.controlName)
      ?.valueChanges.pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((mode) => {
        if (mode === 'text') {
          this.fileAwareFields.forEach((field) => {
            this.formGroup.get(field)?.enable();
            this._store.dispatch(ChatDataActions.clearFiles());
          });
        } else if (mode === 'file') {
          this.fileAwareFields.forEach((field) => {
            this.formGroup.get(field)?.reset();
            this.formGroup.get(field)?.disable();
          });
        }
      });
  }
}
